<template>
  <div>
    <v-img
      max-width="width"
      max-height="80"
      class="my-1"
      contain
      :src="source"
      @error="source = imagePath"
    >
    </v-img>
    <!-- {{ source }} -->
  </div>
</template>

<script>
/*
    - takes two directories, one images and for thumbnails (eg "/images/dir/" & "/images/dir/thumbnails/")
    - tries to show file from the thumbnail directory. If it's not found shows the file from the main directory
    - (file names need to be the same in both directories)
*/
export default {
  name: "ImageThumbnail",
  props: {
    width: { type: Number, default: 150 },
    height: { type: Number, default: 80 },
    img: null,
    root: { type: String, required: true },
    thumbRoot: { type: String, required: true },
  },
  data: function () {
    return {
      source: null,
    };
  },
  methods: {},
  computed: {
    imagePath: function () {
      if (!this.root || !this.img) return null;

      return this.root + this.img;
    },
    thumbPath: function () {
      if (!this.thumbRoot || !this.img) return null;
      return this.thumbRoot + this.img;
    },
  },
  mounted() {
    this.source = this.thumbPath;
  },
};
</script>

<style scoped></style>
